import { useQuery } from "@tanstack/react-query";
import {
  fetchUsersImportRows,
  UserImportRowsParams,
  UserImportRowsResponse
} from "PFCore/services/users/import";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { usersKeys } from "./query_keys";

export const useUsersImportRows = (
  importId: Id,
  params?: UserImportRowsParams,
  options: QueryOptions<UserImportRowsResponse> = {}
) =>
  useQuery<UserImportRowsResponse>({
    queryKey: usersKeys.importRows(importId, params),
    queryFn: () => fetchUsersImportRows(importId, params),
    retry: false,
    ...options
  });
